import React, { useState } from 'react';

import { Body, InputTextField, Modal, RatingNumbers, Title } from '@icarros/ids-react';

import { pushSellerPFDashboardEvent } from '../../../../../../utils/pushToDataLayer';

import { ModalBody } from '../style';
import { FeedbackRatingStepProps } from './types/modal-deactivate';

export function FeedbackRatingStep({
  loading,
  modalOpen,
  handleFeedback,
  handleClose
}: Readonly<FeedbackRatingStepProps>): JSX.Element {
  const [selectedOption, setSelectedOption] = useState('');
  const [feedback, setFeedback] = useState<string>('');
  const inputHasError = !!feedback.match(/[^A-zÀ-ú\s\d.,]+/gm);

  return (
    <Modal
      stateOpen={[
        modalOpen,
        () => {
          pushSellerPFDashboardEvent('voltar', 'seu anúncio foi excluído com sucesso');
          handleClose();
        }
      ]}
      body={
        <ModalBody>
          <Title variant="default" size="base">
            seu anúncio foi desativado com sucesso!
          </Title>
          <Body size="body_2" contrast="default" weight="regular" variant="base">
            De 0 a 10, o quanto você recomenda o icarros para um amigo ou família?
          </Body>
          <Body size="body_2" contrast="default" weight="regular" variant="base">
            <RatingNumbers onChangeState={setSelectedOption} />
            {selectedOption && (
              <InputTextField
                onChange={event => {
                  const { value } = event.target;
                  setFeedback(value);
                }}
                value={feedback}
                placeholder="por que escolheu essa nota? (opcional)"
                maxLength={140}
                isError={inputHasError}
                helperText="Não é possível usar símbolos, como &, @, #, *, $"
              />
            )}
          </Body>
        </ModalBody>
      }
      title=""
      mainButtonText="enviar avaliação"
      disabledMainButton={!selectedOption}
      mainButtonLoading={loading}
      mainButtonMethod={() => {
        if (inputHasError) return;
        pushSellerPFDashboardEvent('enviar avaliação', 'seu anúncio foi excluído com sucesso', {
          opcao_selecionada_1: selectedOption,
          feedback
        });
        handleFeedback(selectedOption, feedback);
      }}
    />
  );
}
